import { Pipe, PipeTransform } from '@angular/core';

import { arquivosExtensoes } from '../arquivo-extensao';

@Pipe({
    name: 'arquivoExtensaoIcon'
})
export class ArquivoExtensaoIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = arquivosExtensoes.findIndex(extensao => extensao.id === value);
        if (index > -1) {
            return arquivosExtensoes[index].iconClass;
        }
        return '';
    }
}
